import { renderDsCheckbox } from '../../../../../shared-ui/ds/checkbox.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

const CHECKBOX_STATES = new Set(['Default', 'Hover', 'Active', 'Focus', 'Disabled', 'Loading']);
const CHECKBOX_SIZES = new Set(['sm', 'md', 'lg']);

export function renderSettingsCheckbox(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const checked = Boolean(normalized.checked);
  const disabled = Boolean(normalized.disabled);
  const state = CHECKBOX_STATES.has(normalized.state)
    ? normalized.state
    : (disabled ? 'Disabled' : checked ? 'Active' : 'Default');
  const size = CHECKBOX_SIZES.has(normalized.size)
    ? normalized.size
    : 'sm';

  return renderDsCheckbox({
    ...normalized,
    checked,
    disabled,
    state,
    size
  });
}
